import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";
import withWaterGymProtection from "../../components/WaterGymProtection";

function WaterGym() {
  return <GameMap config={mapConfigs.watergym} />;
}

export default withWaterGymProtection(WaterGym);